var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedQuizIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 34,
    viewBox: "0 0 28 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7431_11025)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8654 25.5584H11.2137C10.7397 25.5584 10.28 25.3896 9.91929 25.0822C8.84752 24.1689 8.54417 23.891 7.627 23.031C7.22363 22.6528 6.99414 22.1238 6.99414 21.5708V7.58934C6.99414 6.95631 7.50689 6.44116 8.13697 6.44116H19.8654C20.4955 6.44116 21.0083 6.95631 21.0083 7.58934V24.4102C21.0083 25.0433 20.4955 25.5584 19.8654 25.5584ZM19.4309 17.1196C19.6838 17.3892 19.6625 17.8058 19.3832 18.05C18.6318 18.7071 18.1178 19.2535 17.6924 19.8937C17.2643 20.5377 16.9073 21.3046 16.5033 22.4232C16.4255 22.639 16.2374 22.8002 16.0064 22.8496C15.7756 22.8989 15.5346 22.8292 15.3697 22.6653L13.6177 20.9235C13.3552 20.6626 13.3615 20.2457 13.6318 19.9922C13.9021 19.7388 14.334 19.7448 14.5965 20.0058L15.597 21.0005C15.8888 20.3016 16.1894 19.7158 16.5441 19.1822C17.0569 18.4106 17.6637 17.7763 18.4673 17.0736C18.7466 16.8293 19.178 16.85 19.4309 17.1196ZM9.06446 10.1753C8.7517 10.1753 8.49815 10.4439 8.49815 10.7753C8.49815 11.1067 8.7517 11.3753 9.06446 11.3753H18.8322C19.145 11.3753 19.3985 11.1067 19.3985 10.7753C19.3985 10.4439 19.145 10.1753 18.8322 10.1753H9.06446ZM8.49815 14.2249C8.49815 13.8935 8.7517 13.6249 9.06446 13.6249H18.8322C19.145 13.6249 19.3985 13.8935 19.3985 14.2249C19.3985 14.5562 19.145 14.8249 18.8322 14.8249H9.06446C8.7517 14.8249 8.49815 14.5562 8.49815 14.2249ZM9.06446 17.0746C8.7517 17.0746 8.49815 17.3432 8.49815 17.6746C8.49815 18.006 8.7517 18.2746 9.06446 18.2746H12.1613C12.474 18.2746 12.7276 18.006 12.7276 17.6746C12.7276 17.3432 12.474 17.0746 12.1613 17.0746H9.06446Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7431_11025",
    x: -5,
    y: -2,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.36 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7431_11025"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7431_11025",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedQuizIcon);
export default __webpack_public_path__ + "static/media/feed-quiz-icon.373296ec.svg";
export { ForwardRef as ReactComponent };